export default {
	adressFetching: false,
	adressError: false,
	adress: null,
};
